import { Spacing8 } from 'autogen/design-tokens/tokens';
import type { ProductListPartialViewModel } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import Flex from 'components/Layout/components/Flex';
import SortingFilterMenu from './ProductListFilter/components/Filters/SortingFilter/SortingFilterMenu';
import SortingFilterMenuOpener from './ProductListFilter/components/Filters/SortingFilter/SortingFilterMenuOpener';

export default function SortingHeader({ model }: { model: ProductListPartialViewModel }) {
    const { hitsTotalText, showFiltersTop } = model;

    return (
        <Flex.Row gap={Spacing8} justifyContent="space-between" alignItems="center">
            <Typography.Body size="M" strong as="span">
                {hitsTotalText}
            </Typography.Body>

            {showFiltersTop && (
                <>
                    <SortingFilterMenu model={model.productList.sortingOptions} />
                    <SortingFilterMenuOpener model={model.productList.sortingOptions} />
                </>
            )}
        </Flex.Row>
    );
}
